/* import __COLOCATED_TEMPLATE__ from './keyence.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();